import { MixpanelService } from '../../trackingAnalytics/services/mixPanel.service';
import { TrackEventParams } from '../types';

export const useTrackEvent = () => {
  return (params: TrackEventParams) => {
    const { eventName, additionalContent = null } = params;
    MixpanelService.getInstance().storeEvent(eventName, additionalContent);
  };
};
